import { CTA, Text } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayerCloseHandleV2 } from '@volkswagen-onehub/layer-manager';

export default function Disclaimer(props: DisclaimerProps) {
	const { reference, text, close } = props;
	const { t } = useTranslation('ns1', { useSuspense: false });

	return (
		<div className="disclaimer-container">
			<div className="disclaimer-content">
				<Text className="disclaimer-ref">{reference}.</Text>
				<Text className="disclaimer-text">{text}</Text>
			</div>
			<div className="disclaimer-close">
				<CTA onClick={close} tag="button" emphasis="tertiary" aria-label={t('general.close')} iconPosition="top" icon={<Close aria-hidden={true} />} />
			</div>
		</div>
	);
}

export interface DisclaimerProps {
	reference: any;
	text: string;
	close: LayerCloseHandleV2<any>;
}
